export const question = [
  {
    id: 1,
    question: "Eligibility & Requirements",
    answer: [
      {
        item: "Applicant must be aged 18 years and above.",
      },
      {
        item: "Must hold a valid license from a Town Council or Municipality.",
      },
      {
        item: "Must have an active business account with IndoZambia Bank, as disbursements are made directly into these accounts.",
      },
      {
        item: "Completion of the loan application form.",
      },
      {
        item: "Mandatory KYC documentation (to be verified and authenticated).",
      },
      {
        item: "Presanction inspection or due diligence by the branch (with or without agents).",
      },
    ],
  },
  {
    id: 2,
    question: "Purpose",
    answer: [
      {
        item: "The Indo Ka Sumfin Loan is designed to help business persons restart or upscale their businesses.",
      },
    ],
  },
  {
    id: 3,
    question: "Quantum of Finance",
    answer: [
      {
        item: "Minimum loan amount: ZMW 1,000",
      },
      {
        item: "Maximum loan amount: ZMW 10,000",
      },
    ],
  },
  {
    id: 4,
    question: "Security",
    answer: [
      {
        item: "Primary Security: Debenture on stock created using the bank's funds.",
      },
      {
        item: "Collateral Security: None required.",
      },
      {
        item: "Third-Party Guarantee: Not mandatory but preferable for added support.",
      },
      {
        item: "Guarantee Coverage: The loan is insured under the Zambia Credit Guarantee Scheme.",
      },
    ],
  },
  {
    id: 5,
    question: "Repayment Period",
    answer: [
      {
        item: "Loan term: 13 months",
      },
      {
        item: "Repayment begins one month after disbursement and is made through 12 equal monthly installments (EMIs).",
      },
      {
        item: "Refinancing option: After 6 months of timely repayment, borrowers may qualify for an enhanced limit of up to 150% of the previous loan amount (capped at ZMW 15,000).",
      },
    ],
  },
  {
    id: 6,
    question: "Processing Fee",
    answer: [
      {
        item: "A flat fee of ZMW 200 applies to each loan application.",
      },
      {
        item: "No guarantee charges and no prepayment fees.",
      },
    ],
  },
];
